const DATA_TABLE_EVENT_BUS_NAMES = {
    OPEN_FILTER: 'OPEN_FILTER',
    UPDATE_FILTER: 'UPDATE_FILTER'
};

export default DATA_TABLE_EVENT_BUS_NAMES;